import React from 'react'

import { CrossButtonDark } from 'components/Buttons/CrossButton'
import {
	Container,
	CheckImage,
	Description,
	GoBackButton,
} from './Success.styles'

interface SuccessProps {
	text: string;
	header: string;
	buttonText: string;
	description?: boolean;
	practiceName?: string;
	onClose: () => any,
	onBackToJobPostings: () => any,
}

export default function Success(
	{
		text,
		header,
		buttonText,
		description,
		practiceName,
		onClose,
		onBackToJobPostings
	}: SuccessProps,
) {

	return (
		<Container>
			<CheckImage />
			<CrossButtonDark
				onClick={onClose}
			/>
			<p className='thin'>
				{header}
			</p>
			<p>
				{text}
			</p>
			{description && <Description>
				An Important Heads-Up, {practiceName}
				<br/><br/>
				TempStars candidate matching system works best for those offices who have established a track record with our temping service (similar to how Netflix makes better movie recommendations the more you use it).
				<br/><br/>
				Dental Offices who use our temping service and receive consistently positive feedback get <b>5x more top applicants</b> than those who don’t - because these offices achieve TempStars Pro and Elite Status in our system, which highlights their listings and shows top candidates they’ve proven to be great places to work.
				<br/><br/>
				So it’s worth using TempStars for temping - not just because we’re the best at it, but getting great feedback through TempStars tells the TempStars community that you’re a great place to work, it dramatically improves your number of applicants and helps our proprietary Recommendation Engine find you the best fit for your office.
			</Description>}
			<GoBackButton
				onClick={onBackToJobPostings}
			>
				{buttonText}
			</GoBackButton>
		</Container>
	)
}
